export const GOOGLE_ANALYTICS4_EVENTS = {
	LOGIN: 'login',
	LOGIN_INITIATE: 'login_initiate',
	LOGIN_ERROR: 'login_error',
	PAGE_VIEW: 'page_view',
	SERVICE_REGISTER: 'service_register',
	SERVICE_ENROLL: 'service_enroll',
	LOGOUT: 'logout',
	NAVIGATION_INTERACT: 'navigation_interact',
	CTA_CLICK: 'cta_click',
	FORM_START: 'form_start',
	FORM_FILL: 'form_fill',
	FORM_ERROR: 'form_error',
	FORM_SUBMIT_SUCCESS: 'form_submit_success',
	OUTBOUND_LINK_CLICK: 'outbound_link_click',
	ACCORDION_CLICK: 'accordion_click',
	LIVE_CHAT_INTERACT: 'live_chat_interact',
	LINK_CLICK_CONTACT: 'link_click_contact',
	VIDEO_START: 'video_start',
	VIDEO_PROGRESS: 'video_progress',
	VIDEO_COMPLETE: 'video_complete',
	CONTENT_INTERACT: 'content_interact',
	PASSWORD_RESET: 'password_reset',
	PASSWORD_RESET_SUCCESS: 'password_reset_success',
	PATHWAY_INTERACT: 'pathway_interact'
};
